import * as React from "react";

export default class MobileNavbar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstLevelItems: [],
            secondLevelItems: [],
            thirdLevelItems: [],
            backHomeLabel: "Back to Home",
        }
    }

    componentDidMount() {
        this.setState({
            firstLevelItems: this.props.mainNavItem
        });
    }

    nextLevel(item, level) {
        if (level == 1) { this.setState({ firstLevelItems: item.Items }); }
        else if (level == 2) { this.setState({ secondLevelItems: item.Items }); }
        else if (level == 3) { this.setState({ thirdLevelItems: item.Items }); }
    }

    previousLevel(level) {
        if (level == 1) { this.setState({ firstLevelItems: this.props.mainNavItem }); }
        else if (level == 2) { this.setState({ secondLevelItems: [] }); }
        else if (level == 3) { this.setState({ thirdLevelItems: [] }); }
        
    }

    render() {
        const { mainNavItem } = this.props;
        const { firstLevelItems, secondLevelItems, thirdLevelItems, backHomeLabel } = this.state;
        let backTo = "Back to ";
        return (
            <div id="mobileNavbarReact" className="navbar-nav primary-nav d-flex w-100 justify-content-between">
                <ul className={"navbar-items" + (mainNavItem == firstLevelItems ? " active" : "")}>
                    {mainNavItem && mainNavItem.map((item, index) => {
                        return (
                            <li className="nav-item" key={index}>
                                {item.Items && item.Items.length > 0 &&
                                    <a className={"nav-link " + ((item.Items.length > 0) ? 'has-child' : '')} title={item.Title} onClick={this.nextLevel.bind(this, item, 1)} >
                                        {item.Title}
                                        <i className="fa-solid fa-angle-right"></i>
                                    </a>
                                }
                                {item.Items && item.Items.length == 0 &&
                                    <a href={item.Link} className="nav-link" title={item.Title}>{item.Title}</a>
                                }
                                <ul className={"first-level" + ((item.Items == firstLevelItems) ? " active" : "")}>
                                    {item.Items && item.Items.length > 0 &&
                                        <React.Fragment>
                                            <div className="back">
                                                <span className="back-label" onClick={this.previousLevel.bind(this, 1)}>
                                                    <i className="fa-solid fa-angle-left"></i>{backHomeLabel}</span>
                                            </div>
                                            <li className="nav-item">
                                                <a className="nav-link" href={item.Link} title={item.Title}>{item.Title}</a>
                                            </li>
                                        </React.Fragment>
                                    }
                                    {item.Items && item.Items.map((first, findex) => {
                                        return (
                                            <li className="nav-item" key={findex}>
                                                {first.Items && first.Items.length > 0 &&
                                                    <a className={"nav-link " + ((first.Items.length > 0) ? 'has-child' : '')} title={first.Title} onClick={this.nextLevel.bind(this, first, 2)}>
                                                        {first.Title}
                                                        <i className="fa-solid fa-angle-right"></i>
                                                    </a>
                                                }
                                                {first.Items && first.Items.length == 0 &&
                                                    <a href={first.Link} className="nav-link" title={first.Title}>{first.Title}</a>
                                                }
                                                <ul className={"second-level h-100" + ((first.Items == secondLevelItems) ? " active" : "")}>
                                                    {first.Items && first.Items.length > 0 &&
                                                        <React.Fragment>
                                                            <div className="back"> 
                                                                <span className="back-label" onClick={this.previousLevel.bind(this, 2)} title={first.Title}><i className="fa-solid fa-angle-left"></i>{backTo}{first.Title}</span>
                                                            </div>
                                                            <li className="nav-item">
                                                                <a className="nav-link" href={first.Link} title={first.Title}>{first.Title}</a>
                                                            </li>
                                                        </React.Fragment>
                                                    }
                                                    {first.Items && first.Items.map((second, sindex) => {
                                                        return (
                                                            <li className="nav-item" key={sindex}>
                                                                {second.Items && second.Items.length > 0 &&
                                                                    <a className={"nav-link " + ((second.Items.length > 0) ? 'has-child' : '')} title={second.Title} onClick={this.nextLevel.bind(this, second, 3)}>
                                                                        {second.Title}
                                                                        <i className="fa-solid fa-angle-right"></i>
                                                                    </a>
                                                                }
                                                                {second.Items && second.Items.length == 0 &&
                                                                    <a href={second.Link} className="nav-link" title={second.Title}>{second.Title}</a>
                                                                }
                                                                <ul className={"second-level h-100" + ((second.Items == thirdLevelItems) ? " active" : "")}>
                                                                    {second.Items && second.Items.length > 0 &&
                                                                        <React.Fragment>
                                                                            <div className="back"> 
                                                                                <span className="back-label" onClick={this.previousLevel.bind(this, 3)} title={second.Title}><i className="fa-solid fa-angle-left"></i>{backTo}{second.Title}</span>
                                                                            </div>
                                                                            <li className="nav-item">
                                                                                <a className="nav-link" href={second.Link} title={second.Title}>{second.Title}</a>
                                                                            </li>
                                                                        </React.Fragment>
                                                                    }
                                                                    {second.Items && second.Items.map((third, tindex) => {
                                                                        return (
                                                                            <li className="nav-item" key={tindex}>
                                                                                <a href={third.Link} className="nav-link" title={third.Title}>{third.Title}</a>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}